import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { color } from 'd3';

const InfoBubble = ({ message, disabled }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    if (!disabled) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (!disabled) {
      setIsHovered(false);
    }
  };

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <InfoIcon sx={{margin: 1 }} color={disabled ? 'disabled' : 'info'} />
      {isHovered && !disabled && (
        <Box
          sx={{
            backgroundColor: 'rgb(246, 252, 255)',
            borderRadius: '6px',
            padding: '12px',
            position: 'absolute',
            zIndex: 1,
            bottom: '125%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '160px',
            boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.29)',
          }}
        >
          <Typography variant="body2">{message}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default InfoBubble;